import store from '@/store';
/**
 * This service is needed to stop requests
 * when needed. For example if there
 * is some number of requests started to leave
 * and they depend on url parameters and user will
 * get errors. With this controller it will be
 * possible to stop these requests at any time.
 * */
export default class AbortController {
  controller;
  /**
   * Abort controller feature flag
   */
  get isAbortControllerActive() {
    return store.getters['FeatureFlags/abortController'];
  }
  /**
   * The method inits AbortController.
   * */
  onInitAbortController() {
    if (this.controller || this.isAbortControllerActive) {
      return;
    }
    this.controller = new AbortController();
    return this.controller;
  }
  /**
   * The method destroys AbortController.
   * */
  onDestroyAbortController() {
    this.controller = null;
    this.onWarn('AbortController is destroyed');
  }
  /**
   * The method aborts request
   * @params {string} message - Message as reason for abort controller.
   * */
  onAbortRequest(message = '') {
    if (!this.isAbortControllerActive) {
      this.onError('Feature flag is disabled.');
      return;
    }
    if (!this.controller) {
      this.onError('Abort controller is not defined.');
      return;
    }
    const {
      abort,
      aborted,
      reason,
    } = this.controller;
    abort(message);
    return {
      aborted,
      reason,
    };
  }
  /**
   * The method throws an error
   * @params {string} message - Message for error.
   * */
  onError(message = '') {
    if (!message) {
      return;
    }
    const error = new Error(`AbortController: ${message}`);
    console.error(error);
  }
  /**
   * The method throws a warn for notification
   * @params {string} message - Message for notification.
   * */
  onWarn(message = '') {
    if (!message) {
      return;
    }
    console.warn(`AbortController: ${message}`);
  }
}
